<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-12 15:31:45
-->
<template>
    <div class="add-danwei">
        <el-form
            ref="ruleForm"
            :model="viewData"
            :rules="rules"
            label-width="100px"
        >
            <el-form-item label="标题" prop="title">
                <el-input v-model="viewData.title" />
            </el-form-item>
            <el-form-item label="小区" prop="commId">
                <el-select
                        v-model="viewData.commId"
                        clearable
                        filterable
                        placeholder="请选择小区"
                >
                <el-option v-for="item in optionList"
                            :key="item.id"
                            :label="item.commName"
                            :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="内容"
                            prop="content">
                <tinymce ref="tinymce"
                        v-if="showUpload"
                        v-model="viewData.content"
                        :height="300" />
            </el-form-item>
            <el-form-item label="发布时间">
            <el-date-picker v-model="viewData.publish_at"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="发布时间">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="来源">
                <el-input v-model="viewData.source" />
            </el-form-item>
            <el-form-item label="排序">
                <el-input-number
                    size="mini"
                    style="width: 100px"
                    v-model="viewData.sort"
                    controls-position="right"
                    :min="0"
                ></el-input-number>
            </el-form-item>
            <!-- <el-form-item label="状态">
                <el-switch
                    v-model="viewData.status"
                    class="drawer-switch"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                />
            </el-form-item> -->
        </el-form>
        <div class="fix-fotter">
            <el-button style="min-width: 117px;background: #1067E0;font-size: 16px;border-color: #1067E0;" size="mini" type="primary" @click="tijiao('ruleForm')">提交</el-button>
        </div>
    </div>
</template>

<script>
import fetch from "@/api/tianzheng/member";
import Qu from "@/api/tianzheng/Qu";
import Tinymce from '@/components/Tinymce'
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
    data() {
        return {
            showUpload:false,
            optionList: [],
            viewData: {
                id:'',
                name: "",
                commId: "",
                content: "",
                source: "",
                publish_at: "",
                sort: 0,
                status: 1,
            },
            rules: {
                title: [
                    {
                        required: true,
                        message: "请输入标题",
                        trigger: "blur",
                    },
                ],
                commId: [
                    {
                        required: true,
                        message: "请选择小区",
                        trigger: "blur",
                    },
                ],
                content: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    components: {
        Pagination,
        Tinymce
    },
    created() {
        this.getSelectCity()
    },
    methods: {
        // 获取下拉列表
        getSelectCity () {
            Qu.select({}).then(res => {
                if (res.code == 200) {
                this.optionList = res.result;
                }
            })
        },
        /**
         * @name: 初始化列表
         * @param {*} obj
         * @return {*}
         * @desc:
         */
        initFun(obj) {
            let that = this
            this.viewData = {
                id: "",
                name: "",
                status: 1,
                sort: 0,
            }
            this.showUpload = true
            if (obj.id) {
                // 编辑
                this.viewData.id = obj.id;
                fetch.detail({ id: obj.id }).then((res) => {
                    console.log(res)
                    if (res.code == 200) {
                        that.viewData = res.result
                        that.viewData.id = res.result.id;
                        if (that.viewData.content) {
                            that.$refs["tinymce"].setContent(this.viewData.content);
                        } else {
                            that.$refs["tinymce"].setContent('');
                        }
                    }
                });
            } else {
                // 新增
            }
        },
        /**
         * @name: 提交
         * @param {*} formName
         * @return {*}
         * @desc: 
         */		
         tijiao(formName) {
            let that = this
            console.log(this.viewData)
            this.$refs[formName].validate(valid => {
                if (valid) {
					if(this.viewData.id){
						// 编辑
						fetch.edit(this.viewData).then(res=>{
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						})
					}else{
						// 新增
						fetch.create(this.viewData).then(res=>{
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						}) 
					}
                      
                } else {
                    this.$message.warning(this.$t('form.verifyMsg'))
                }
            })
        },
        /**
         * @name: 清空form
         * @return {*}
         * @desc:
         */
        resetForm() {
            if (this.$refs["tinymce"]) {
                this.$refs["tinymce"].setContent('');
            }
            this.$refs["ruleForm"].resetFields();
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
